<template>
  <div class="top-menu-container">
    <el-menu
        class="el-menu-demo"
        mode="horizontal"
        :ellipsis=false
        :router=true
        :default-active="$router.currentRoute.value.fullPath"
        active-text-color="#e9bb1d"
    >
      <template v-for="menu in content" :key="menu.id">
        <el-menu-item v-if="menu.children.length == 0 && menu.is_external_link===0" :index="'/article'+menu.url" @click="go(menu.url, menu.is_index)">{{ menu.name }}</el-menu-item>
        <li v-else-if="menu.children.length == 0 && menu.is_external_link===1" class="el-menu-item" :index="'/article'+menu.url" @click="to_external_link(menu.url)">{{ menu.name }}</li>

        <el-sub-menu v-if="menu.children.length >= 1" :index="'/article'+menu.url">
          <template #title>{{ menu.name }}</template>
          <template v-for="sub_menu in menu.children" :key="sub_menu.id" >
            <el-menu-item v-if="sub_menu.is_external_link===0" :index="'/article'+sub_menu.url" @click="go(sub_menu.url, sub_menu.is_index)">{{ sub_menu.name }}</el-menu-item>
            <li class="el-menu-item" v-else @click="to_external_link(sub_menu.url)">{{ sub_menu.name }}</li>
          </template>
        </el-sub-menu>
      </template>
    </el-menu>
  </div>
</template>

<script>
import api from "../api/api";

export default ({
  name: "MainMenu",
  data() {
    return {
      content: null
    }
  },
  async mounted() {
    let json = await api.common.menu({'type':'main'})
    this.content = json.data;
  },
  methods:{
    go: function (url, is_index) {
      let url_prefix = ''
      is_index=== 1 ? url_prefix='' : url_prefix='/article'
      //if (is_external_link === 0) {
        this.$router.push(url_prefix + url)
      /*} else {
        window.open(url);
      }*/
    },
    to_external_link: function (url) {
      window.open(url)
    }
  }
})
</script>

<style scoped>
.top-menu-container{
  width: 1200px;
  margin: 0 auto;
  background: #BC0000;
  overflow: hidden;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/deep/ .el-menu-item {
  font-size: 16px!important;
}
.el-menu {
  border: none!important;
  --el-menu-hover-bg-color: #A10000;
  --el-menu-text-color: #fff;
  --el-menu-hover-text-color: #e16e6e;
  //--el-menu-active-color: #fff!important;
  --el-menu-bg-color: #ffffff50;
}
.top-menu-container > ul {
  width: 1200px;
  height: 48px;
  --el-menu-bg-color: #545c6400!important;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: flex-start;
  align-items: center;
}
.top-menu-container > ul > li {
  width: 170px;
  height: 48px;
  line-height: 48px;
}
.top-menu-container > ul > li:after, /deep/ .el-menu--horizontal>.el-sub-menu .el-sub-menu__title:after{
  content: "";
  width: 1px;
  height: 20px;
  background-color: #fff;
  position: absolute;
  right: 0px;
}
/deep/ .el-menu--horizontal>.el-menu-item:last-child:after {
  width: 0px;
}
/deep/ .el-menu--horizontal>.el-sub-menu:last-child .el-sub-menu__title:after {
  width: 0px;
}
/deep/ .el-menu--horizontal>.el-menu-item {
  font-size: 16px;
}
/deep/ .el-menu--horizontal>.el-menu-item:hover, /deep/ .el-menu--horizontal>.el-menu-item:active {
  color: #fff!important;
  --el-menu-hover-text-color: #fff!important;
}
/deep/ .el-menu--horizontal>.el-sub-menu .el-sub-menu__title {
  height: 48px;
  line-height: 48px;
  display: flex;
  align-items: center;
  flex-direction: row;
  align-content: center;
  justify-content: center;
  font-size: 16px;
}
/deep/ .el-menu--horizontal>.el-sub-menu.is-active .el-sub-menu__title:hover {
  color:#BC0000;
}
.el-popper.is-light{
  background: #ffffff50!important;
}
</style>